// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","573":"component---src-pages-system-requirements-js","778":"component---src-pages-rules-js"}[chunkId] + "-" + {"293":"e9a969a3deea421f5865","573":"1e85710078f89de4773a","778":"494025af37abb03ecd70"}[chunkId] + ".js";
};